import React, { useEffect, useState } from "react";
import API from "../Services/AccessRight";
import API1 from "../Services/Employee";

import LocationList from "../Components/Location";
import DesignationList from "../Components/Designation";
import { toast, ToastContainer } from "react-toastify";

const AddAccessRight = () => {
    const [accessRight, setAccessRight] = useState({});
    const [employee, setEmployee] = useState([]);
    const [locationId, setLocationId] = useState("");
    const [designationId, setDesignationId] = useState("");
    const [employeeId, setEmployeeId] = useState("");
    const [checkedAccessRights, setCheckedAccessRights] = useState({});

    useEffect(() => {
        bindAccessRight();
    }, []);

    useEffect(() => {
        if (designationId) {
            bindEmployeeList();
        } else {
            setEmployee([]);
        }
    }, [designationId]);

    const bindEmployeeList = async () => {
        try {
            const payload = { limit: 0, is_active: 1, designation_id: designationId,location_id:locationId };
            // const payload = { limit: 0, is_active: 1, search: designationId };
            //console.log('Fetching employees with payload:', payload);
            const response = await API1.bindEmployeeList(payload);
           // console.log("response...",response)
            setEmployee(response.data.data);
        } catch (error) {
            if (error.response) {
                if (error.response.status === 500) {
                    toast.error("Server Error: Please try again later.");
                } else if (error.response.status === 403) {
                    window.location.replace("/Login");
                } else {
                    toast.error(`Error ${error.response.status}:`, error.response.data);
                }
            }
            console.error("Error fetching employee list:", error);
        }
    };

    const bindAccessRight = async () => {
        try {
            const response = await API.Bind_Access_Right();
            const modules = response.data.data;
            const groupedModules = modules.reduce((acc, module) => {
                if (!acc[module.name]) {
                    acc[module.name] = [];
                }
                if (Array.isArray(module.RoutesModel)) {
                    acc[module.name] = [...acc[module.name], ...module.RoutesModel];
                }
                return acc;
            }, {});

            setAccessRight(groupedModules);
        } catch (error) {
            if (error.response) {
                if (error.response.status === 500) {
                    toast.error("Server Error: Please try again later.");
                } else if (error.response.status === 403) {
                    window.location.replace("/Login");
                } else {
                    toast.error(`Error ${error.response.status}:`, error.response.data);
                }
            }
            console.error("Error fetching access rights:", error);
        }
    };

    const handleAccessRightChange = (id) => {
        setCheckedAccessRights((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };

    const handleEmployeeChange = (e) => {
       // console.log("e.......",e)
        setEmployeeId(e.target.value);
    };

    const handleSubmit = async () => {
        try {
            const selectedRoutes = Object.keys(checkedAccessRights)
                .filter((key) => checkedAccessRights[key])
                .map((id) => parseInt(id, 10));

            let payload = {};
            let response;

            if (!employeeId) {
                payload = {
                    designation_id: designationId,
                    route_id: selectedRoutes,
                    type: "route",
                    is_active: 1,
                };
                response = await API.create_Access_Right(payload);
            } else {
                payload = {
                    employee_id: employeeId,
                    route_id: selectedRoutes,
                    type: "route",
                };
                response = await API.employee_Access_Right(payload);
            }
            toast.success(response.data.message)
            setTimeout(() => window.location.reload(), 2000);

        } catch (error) {
            if (error.response) {
                if (error.response.status === 500) {
                    toast.error("Server Error: Please try again later.");
                } else if (error.response.status === 403) {
                    window.location.replace("/Login");
                } else {
                    toast.error(`Error ${error.response.status}:`, error.response.data);
                }
            }
            console.error("Error submitting access rights:", error);
            toast.error("Failed to save access rights.");
            toast.error("failed")
        }


    };

    const handleSearch = async () => {

        const payload = {
            designation_id: designationId,
            emp_id: employeeId
        };

        try {
            const response = await API.get_Employee_Access_Right(payload);
            const accessRights = Object.values(response?.data?.data || {}).flat();
            const checkedRights = accessRights.reduce((acc, item) => {
                acc[item.id] = true;
                return acc;
            }, {});
            setCheckedAccessRights(checkedRights);

        } catch (error) {
            if (error.response) {
                if (error.response.status === 500) {
                    toast.error("Server Error: Please try again later.");
                } else if (error.response.status === 403) {
                    window.location.replace("/Login");
                } else {
                    toast.error(`Error ${error.response.status}:`, error.response.data);
                }
            }
            console.error("Error fetching employee access rights:", error);
        }
    };
    const handleCancel = () => {
        window.location.reload();
    }
    const handleModuleToggle = (pages) => {

        const updatedRights = { ...checkedAccessRights };
        const allChecked = pages.every((page) => checkedAccessRights[page.id]);
        pages.forEach((page) => {
            updatedRights[page.id] = !allChecked;
        });
        setCheckedAccessRights(updatedRights);
    };

    return (
        <div className="col-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">Add New</h4>
                    <div className="forms-sample">
                        <div className="row">
                            <div className="col-md-3">
                                <LocationList
                                    selectedLocation={locationId}
                                    setSelectedLocation={setLocationId}
                                />
                            </div>
                            <div className="col-md-3">
                                <DesignationList
                                    selectedDesignation={designationId}
                                    setSelectedDesignation={setDesignationId}
                                />
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="employee">Employee Name <span style={{ color: "red" }}>*</span></label>
                                    <select
                                        className="form-select"
                                        id="ddlEmployee"
                                        value={employeeId}
                                        onChange={handleEmployeeChange}
                                    >
                                        <option value="">Select</option>
                                        {employee.length > 0 ? (
                                            employee.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.first_name} {item.last_name}
                                                </option>
                                            ))
                                        ) : (
                                            <option disabled>No employee available</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3 mt-4">
                                <label></label>
                                <button type="button" className="btn btn-success" onClick={handleSearch}>Search</button>
                            </div>
                        </div>

                        <div className="container mt-2">
                            <div className="row">
                                {Object.entries(accessRight).map(([moduleName, routes]) => (
                                    <div key={moduleName} className="col-md-6 col-lg-4 mb-4">
                                        <div className="card h-100 shadow-sm border-primary">
                                            <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between">
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        checked={routes.every((page) => checkedAccessRights[page.id])}
                                                        onChange={() => handleModuleToggle(routes)}
                                                        style={{ border: '2px solid black' }}
                                                    />
                                                    <strong>{moduleName}</strong>
                                                </div>
                                            </div>

                                            <div className="card-body">
                                                {Array.isArray(routes) && routes.length > 0 ? (
                                                    <div className="mt-1">
                                                        {routes.map((page) => (
                                                            <div key={page.id} className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input me-2"
                                                                    id={`checkbox-${moduleName}-${page.id}`}
                                                                    value={page.route}
                                                                    checked={checkedAccessRights[page.id] || false}
                                                                    onChange={() => handleAccessRightChange(page.id)}
                                                                    style={{ border: '2px solid black' }}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`checkbox-${moduleName}-${page.id}`}
                                                                >
                                                                    {page.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-muted">No access rights available</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="mt-3">
                            <button
                                type="button"
                                onClick={handleSubmit}
                                className="btn btn-primary me-2"

                            >
                                Submit
                            </button>
                            <button className="btn btn-light" type="button" onClick={handleCancel}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default AddAccessRight;

